/**
 * Suggest the visitor's geo-matched Shopify market instead of auto-redirecting.
 * Respects explicit footer market/language choices.
 *
 * Config JSON lives in #reruption-geo-config (set by reruption-de-de-redirect.liquid).
 */
(function () {
  var STORAGE_PREFERENCE = 'zenbox_market_preference';
  var STORAGE_STAY = 'zenbox_geo_stay';

  var configEl = document.getElementById('reruption-geo-config');
  if (!configEl) {
    return;
  }

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var MARKET_SEGMENTS = [
    'de-de', 'en-de', 'de-at', 'en-at', 'de-ch', 'en-ch',
    'en-be', 'en-dk', 'en-fr', 'en-it', 'en-se', 'en-rs', 'dk-dk'
  ];
  // Auch Märkte, die oben fehlen (z. B. de-be): Shopify-Präfixe haben immer die Form xx-yy.
  // Ohne das wurde beim Wechseln aus /de-be/… die Adresse /de-de/de-be/… gebaut (404).
  function isMarketSegment(segment) {
    return MARKET_SEGMENTS.indexOf(segment) !== -1 || /^[a-z]{2}-[a-z]{2}$/.test(segment || '');
  }

  var BLOCKED_PREFIXES = [
    '/cart', '/checkout', '/account', '/tools', '/apps',
    '/cdn', '/api', '/localization', '/admin', '/challenge',
    '/password', '/services', '/sf_private_access_tokens'
  ];

  var COUNTRY_LABELS = {
    de: {
      DE: 'Deutschland', AT: 'Österreich', CH: 'Schweiz', BE: 'Belgien',
      DK: 'Dänemark', FR: 'Frankreich', IT: 'Italien', SE: 'Schweden', RS: 'Serbien'
    },
    en: {
      DE: 'Germany', AT: 'Austria', CH: 'Switzerland', BE: 'Belgium',
      DK: 'Denmark', FR: 'France', IT: 'Italy', SE: 'Sweden', RS: 'Serbia'
    }
  };

  var COPY = {
    de: {
      title: 'Passender Shop für deinen Standort',
      body: 'Wir haben erkannt, dass du aus {country} kommst. Möchtest du zum passenden Shop wechseln? Dort siehst du lokale Preise und Versandoptionen.',
      switch: 'Wechseln',
      stay: 'Hier bleiben'
    },
    en: {
      title: 'Store for your location',
      body: 'It looks like you are visiting from {country}. Switch to the matching store for local prices and delivery options?',
      switch: 'Switch store',
      stay: 'Stay here'
    }
  };

  var CURRENT_COUNTRY = config.currentCountry || '';
  var CURRENT_LANGUAGE = config.currentLanguage || '';
  var uiLang = String(config.uiLanguage || document.documentElement.lang || 'de').toLowerCase();
  if (uiLang.indexOf('en') === 0) {
    uiLang = 'en';
  } else {
    uiLang = 'de';
  }

  var path = window.location.pathname;
  var search = window.location.search || '';

  function isBlockedPath(urlPath) {
    return BLOCKED_PREFIXES.some(function (prefix) {
      return urlPath === prefix || urlPath.indexOf(prefix + '/') === 0;
    });
  }

  function urlPathHasExtension(urlPath) {
    var lastSegment = urlPath.split('/').pop() || '';
    return lastSegment.indexOf('.') !== -1;
  }

  if (isBlockedPath(path) || urlPathHasExtension(path)) {
    return;
  }

  var parts = path.split('/').filter(Boolean);
  var firstSegment = parts[0] || '';
  var onMarketUrl = isMarketSegment(firstSegment);
  var stayKey = firstSegment || '__root__';

  if (sessionStorage.getItem(STORAGE_PREFERENCE) === firstSegment && firstSegment) {
    return;
  }
  if (sessionStorage.getItem(STORAGE_STAY) === stayKey) {
    return;
  }

  function segmentForCountry(country, preferEnglish, preferDanish) {
    if (country === 'DE') {
      return preferEnglish ? 'en-de' : 'de-de';
    }
    if (country === 'AT') {
      return preferEnglish ? 'en-at' : 'de-at';
    }
    if (country === 'CH') {
      return preferEnglish ? 'en-ch' : 'de-ch';
    }
    if (country === 'BE') return 'en-be';
    if (country === 'DK') {
      return preferDanish ? 'dk-dk' : 'en-dk';
    }
    if (country === 'FR') return 'en-fr';
    if (country === 'IT') return 'en-it';
    if (country === 'SE') return 'en-se';
    if (country === 'RS') return 'en-rs';
    return preferEnglish ? 'en-de' : 'de-de';
  }

  function countryFromSegment(segment) {
    var suffix = segment.split('-')[1];
    var map = {
      de: 'DE', at: 'AT', ch: 'CH', be: 'BE', dk: 'DK',
      fr: 'FR', it: 'IT', se: 'SE', rs: 'RS'
    };
    return map[suffix] || '';
  }

  function marketLabel(segment) {
    var bits = segment.split('-');
    var lang = bits[0];
    var countryCode = countryFromSegment(segment);
    var countryName = (COUNTRY_LABELS[uiLang] && COUNTRY_LABELS[uiLang][countryCode]) || countryCode;
    if (lang === 'en') {
      return uiLang === 'en' ? ('English · ' + countryName) : ('Englisch · ' + countryName);
    }
    if (lang === 'de') {
      return uiLang === 'en' ? ('German · ' + countryName) : ('Deutsch · ' + countryName);
    }
    return countryName;
  }

  function apiRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return onMarketUrl ? '/' + firstSegment + '/' : '/';
  }

  function resolveGeoCountry(data) {
    if (data.suggestions && data.suggestions.length > 0) {
      var suggestion = data.suggestions[0].parts && data.suggestions[0].parts.country;
      if (suggestion && suggestion.handle) {
        return suggestion.handle;
      }
    }

    var detected = data.detected_values && data.detected_values.country;
    if (detected && detected.handle && detected.handle !== CURRENT_COUNTRY) {
      return detected.handle;
    }

    return null;
  }

  function stripLeadingMarketSegments(urlPath) {
    var segments = urlPath.split('/').filter(Boolean);
    while (segments.length > 0 && isMarketSegment(segments[0])) {
      segments.shift();
    }
    return segments.length ? '/' + segments.join('/') : '/';
  }

  function buildTargetPath(expectedSegment) {
    var cleanPath = stripLeadingMarketSegments(path);
    if (cleanPath === '/') {
      return '/' + expectedSegment;
    }
    return '/' + expectedSegment + cleanPath;
  }

  function injectStyles() {
    if (document.getElementById('reruption-geo-modal-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'reruption-geo-modal-styles';
    style.textContent = ''
      + '.reruption-geo-modal{position:fixed;inset:0;z-index:10050;display:flex;align-items:flex-end;justify-content:center;padding:20px;background:rgba(17,17,17,.48)}'
      + '.reruption-geo-modal__panel{width:min(100%,420px);background:#fff;color:#111;border-radius:18px;padding:22px 22px 18px;box-shadow:0 18px 50px rgba(0,0,0,.22)}'
      + '.reruption-geo-modal__title{margin:0 0 10px;font-size:1.12rem;line-height:1.3;font-weight:700}'
      + '.reruption-geo-modal__body{margin:0 0 18px;font-size:.95rem;line-height:1.5;color:#444}'
      + '.reruption-geo-modal__actions{display:flex;gap:10px;flex-wrap:wrap}'
      + '.reruption-geo-modal__btn{appearance:none;border:0;border-radius:999px;padding:12px 18px;font:inherit;font-size:.95rem;font-weight:600;cursor:pointer}'
      + '.reruption-geo-modal__btn--primary{background:#09398a;color:#fff}'
      + '.reruption-geo-modal__btn--secondary{background:#eef2f7;color:#111}'
      + '@media (min-width:700px){.reruption-geo-modal{align-items:center;padding:24px}}';
    document.head.appendChild(style);
  }

  function showModal(targetPath, geoCountry, expectedSegment) {
    if (document.getElementById('reruption-geo-modal')) {
      return;
    }

    injectStyles();

    var labels = COUNTRY_LABELS[uiLang] || COUNTRY_LABELS.de;
    var copy = COPY[uiLang] || COPY.de;
    var countryName = labels[geoCountry] || geoCountry;
    var overlay = document.createElement('div');
    overlay.id = 'reruption-geo-modal';
    overlay.className = 'reruption-geo-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'reruption-geo-modal-title');

    overlay.innerHTML = ''
      + '<div class="reruption-geo-modal__panel">'
      + '<h2 id="reruption-geo-modal-title" class="reruption-geo-modal__title">' + copy.title + '</h2>'
      + '<p class="reruption-geo-modal__body">' + copy.body.replace('{country}', countryName) + '</p>'
      + '<div class="reruption-geo-modal__actions">'
      + '<button type="button" class="reruption-geo-modal__btn reruption-geo-modal__btn--primary" data-action="switch">'
      + copy.switch + ' (' + marketLabel(expectedSegment) + ')'
      + '</button>'
      + '<button type="button" class="reruption-geo-modal__btn reruption-geo-modal__btn--secondary" data-action="stay">'
      + copy.stay
      + '</button>'
      + '</div>'
      + '</div>';

    function closeModal() {
      overlay.remove();
    }

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        sessionStorage.setItem(STORAGE_STAY, stayKey);
        closeModal();
      }
    });

    overlay.querySelector('[data-action="stay"]').addEventListener('click', function () {
      sessionStorage.setItem(STORAGE_STAY, stayKey);
      closeModal();
    });

    overlay.querySelector('[data-action="switch"]').addEventListener('click', function () {
      sessionStorage.setItem(STORAGE_PREFERENCE, expectedSegment);
      window.location.assign(targetPath + search);
    });

    document.body.appendChild(overlay);
  }

  var excludeCountry = CURRENT_COUNTRY;
  if (!excludeCountry && onMarketUrl) {
    excludeCountry = countryFromSegment(firstSegment);
  }

  var apiUrl = apiRoot() + 'browsing_context_suggestions.json?country%5Benabled%5D=true';
  if (excludeCountry) {
    apiUrl += '&country%5Bexclude%5D=' + encodeURIComponent(excludeCountry);
  }

  fetch(apiUrl, { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('geo lookup failed');
      }
      return response.json();
    })
    .then(function (data) {
      var geoCountry = resolveGeoCountry(data);
      if (!geoCountry) {
        return;
      }

      var htmlLang = (document.documentElement.lang || '').toLowerCase();
      var urlLang = onMarketUrl ? firstSegment.split('-')[0] : '';
      var lang = String(CURRENT_LANGUAGE || '').toLowerCase();
      var preferEnglish = urlLang === 'en'
        || lang.indexOf('en') === 0
        || htmlLang.indexOf('en') === 0;
      var preferDanish = urlLang === 'dk'
        || lang.indexOf('da') === 0
        || htmlLang.indexOf('da') === 0;

      var expectedSegment = segmentForCountry(geoCountry, preferEnglish, preferDanish);
      var urlMarketCountry = onMarketUrl ? countryFromSegment(firstSegment) : '';

      var needsSuggestion = !onMarketUrl
        || geoCountry !== urlMarketCountry
        || firstSegment !== expectedSegment;

      if (!needsSuggestion) {
        return;
      }

      var targetPath = buildTargetPath(expectedSegment);
      if (targetPath === path) {
        return;
      }

      showModal(targetPath, geoCountry, expectedSegment);
    })
    .catch(function () {
      // Ignore GeoIP lookup failures
    });
})();
